import { Button, FormLayout, Label, RadioButton, Select } from "@shopify/polaris";
import { asChoiceField } from "@shopify/react-form";
import { ProductObj, VariantsObj } from "../../apps/Bundles/Types";
import styles from "./InclusionExclusionProducts.module.css";
import CloseIcon from "../Icons/CloseIcon";
import { FbtProductLimits } from "../../apps/Bundles/constants";

type InclusionExclusionProductsType = {
    inclusionExclusionType: any;
    inclusionExclusionArr: any;
    limitCheck?: any;
    limitCheckKey?: any;
    inclusionExclusionTypeKey?: any;
    inclusionExclusionArrKey?: any;
    dispatchBundleConfig: any;
};

const InclusionExclusionProducts = ({
    inclusionExclusionType,
    inclusionExclusionArr,
    limitCheck,
    limitCheckKey,
    inclusionExclusionTypeKey,
    inclusionExclusionArrKey,
    dispatchBundleConfig,
}: InclusionExclusionProductsType) => {
    const handleProductSearch = async (initialQuery: string = "") => {
        const preSelected = inclusionExclusionArr.value.map((product: ProductObj) => ({
            id: product?.id,
            variants: product?.variants.map((variant: VariantsObj) => ({
                id: variant?.id,
            })),
        }));
        const selected: any = await shopify.resourcePicker({
            type: "product",
            multiple: true,
            query: initialQuery,
            action: "select",
            selectionIds: preSelected,
            filter: {
                query: "status:active AND published_status:published",
                variants: false,
            },
        });
        if (selected) {
            const productsArr: ProductObj[] = [];
            selected?.flatMap((product: any) => {
                productsArr.push({
                    id: product?.id,
                    images: product?.images,
                    title: product?.title,
                    handle: product?.handle,
                    quantity: 1,
                    maxProductStock: product?.totalInventory,
                    selectedVariants: [],
                    subscriptions: [],
                    oneTimePurchase: true,
                    isSubscribed: false,
                    variants: product?.variants?.map((variant: VariantsObj) => ({
                        image: { ...variant.image },
                        id: variant?.id,
                        displayName: variant.displayName,

                        title: variant?.title?.toLowerCase() == "default title" ? product?.title : variant?.title,
                        price: variant?.price,
                        quantity: 1,
                        selectedOptions: variant?.selectedOptions,
                        copyPrice: variant.price,
                        compareAtPrice: variant.compareAtPrice ? variant.compareAtPrice : variant.price,
                    })),
                    options: product?.options,
                });
            });

            inclusionExclusionArr.onChange(productsArr);
            dispatchBundleConfig({
                payload: productsArr,
                key: [inclusionExclusionArrKey],
            });
        }
    };

    const removeProduct = (pId: string = "") => {
        const temp: ProductObj[] = [...inclusionExclusionArr.value];
        const idx = temp.findIndex((p) => p.id == pId);
        if (idx >= 0) {
            temp.splice(idx, 1);
            dispatchBundleConfig({
                payload: temp,
                key: [inclusionExclusionArrKey],
            });
            inclusionExclusionArr.onChange(temp);
        }
    };

    return (
        <>
            <FormLayout>
                {limitCheck && (
                    <>
                        <div className={styles.customLabelWrapper} style={{ marginBottom: "5px" }}>
                            <Label id="fbt_show_checkboxes">Product Limit</Label>
                        </div>
                        <div className={`${styles.formCol}`}>
                            <Select
                                label={"Set how many products should appear"}
                                placeholder={"Product Limit"}
                                options={FbtProductLimits}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: +val,
                                        key: [limitCheckKey],
                                    });
                                    limitCheck.onChange(+val as any);
                                }}
                                value={limitCheck.value}
                            />
                        </div>
                    </>
                )}
                <div className={styles.customLabelWrapper}>
                    <div className={styles.customLabelWrapper} style={{ marginBottom: "5px" }}>
                        <Label id="inclusionExclusionType">Choose Products to show AI Suggestions for :</Label>
                    </div>
                </div>
                <div className={`${styles.formCol}`}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "-5px",
                        }}
                    >
                        <RadioButton
                            label={"All Products"}
                            id={"every"}
                            value={"every"}
                            name="inclusionExclusionType"
                            {...asChoiceField(inclusionExclusionType, "every")}
                            onChange={(status, val) => {
                                dispatchBundleConfig({
                                    payload: "every",
                                    key: [inclusionExclusionTypeKey],
                                });
                                inclusionExclusionType.onChange(val);
                                dispatchBundleConfig({
                                    payload: [],
                                    key: [inclusionExclusionArrKey],
                                });
                                inclusionExclusionArr.onChange([]);
                            }}
                        />
                        <RadioButton
                            label={"Specific Products"}
                            id={"include"}
                            value={"include"}
                            name="inclusionExclusionType"
                            {...asChoiceField(inclusionExclusionType, "include")}
                            onChange={(status, val) => {
                                dispatchBundleConfig({
                                    payload: val,
                                    key: [inclusionExclusionTypeKey],
                                });
                                inclusionExclusionType.onChange(val);
                                dispatchBundleConfig({
                                    payload: [],
                                    key: [inclusionExclusionArrKey],
                                });
                                inclusionExclusionArr.onChange([]);
                            }}
                        />
                        <RadioButton
                            label={"Exclude Products"}
                            id={"exclude"}
                            value={"exclude"}
                            name="inclusionExclusionType"
                            {...asChoiceField(inclusionExclusionType, "exclude")}
                            onChange={(status, val) => {
                                dispatchBundleConfig({
                                    payload: val,
                                    key: [inclusionExclusionTypeKey],
                                });

                                inclusionExclusionType.onChange(val);
                                dispatchBundleConfig({
                                    payload: [],
                                    key: [inclusionExclusionArrKey],
                                });
                                inclusionExclusionArr.onChange([]);
                            }}
                        />
                    </div>
                </div>
                {inclusionExclusionType.value != "every" && (
                    <div className={styles.customLabelWrapper}>
                        <Label id="inclusionExclusionType">
                            {/* Select the products for which you'd like to{" "}
                            {inclusionExclusionType.value == "include" ? "display" : "hide"} Quantity break offers */}
                            Select the products for which you'd like to{" "}
                            {inclusionExclusionType.value == "include" ? "display" : "hide"} AI-generated offers
                        </Label>
                        <div className={styles.customLabelWrapper} style={{ marginBottom: "5px" }}>
                            <div className={styles.productNameWrapper}>
                                <div
                                    className={styles.productName}
                                    style={{
                                        width: "max-content",
                                        visibility: inclusionExclusionArr.value?.length ? "visible" : "hidden",
                                    }}
                                >
                                    {`${inclusionExclusionType.value == "include" ? "Show" : "Hide"} offer for ${
                                        inclusionExclusionArr.value?.length
                                    } product${inclusionExclusionArr.value?.length > 1 ? "s" : ""}`}
                                </div>

                                {!!inclusionExclusionArr?.value?.length && (
                                    <Button onClick={() => handleProductSearch()} variant={"secondary"}>
                                        + Add Products
                                    </Button>
                                )}
                            </div>
                            {inclusionExclusionArr.value.length ? (
                                <span
                                    style={{
                                        display: "inline-block",
                                        maxHeight: 280,
                                        overflowY: "auto",
                                        width: "100%",
                                        border: "1px dashed var(--p-color-border)",
                                        borderRadius: "var(--p-border-radius-300)",
                                    }}
                                >
                                    <div className={styles.productsRender}>
                                        {inclusionExclusionArr?.value?.map((product: any, pIdx: number) => (
                                            <div
                                                key={product?.variants[0]?.id + pIdx}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    borderRadius: 10,
                                                    backgroundColor: "white",
                                                    padding: "5px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%",
                                                        cursor: "default",
                                                    }}
                                                >
                                                    <div className={styles.productMeta}>
                                                        <div className={styles.productName}>
                                                            <div className={styles.productImageWrapper}>
                                                                <img
                                                                    alt={product?.images[0]?.altText}
                                                                    src={product?.images[0]?.originalSrc}
                                                                    style={{}}
                                                                />
                                                            </div>
                                                            <div className={styles.productTitleWrapper}>
                                                                <div
                                                                    style={{
                                                                        whiteSpace: "normal",
                                                                        cursor: "pointer",
                                                                        textDecoration: "underline",
                                                                    }}
                                                                    onClick={() => {
                                                                        if (shopify.config.shop) {
                                                                            window.open(
                                                                                `https://${shopify.config.shop}/products/${product?.handle}`,
                                                                                "_blank",
                                                                            );
                                                                        }
                                                                    }}
                                                                    className={styles.productTitle}
                                                                >
                                                                    {product?.title}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            onClick={() => {
                                                                removeProduct(product?.id);
                                                            }}
                                                            style={{
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                marginRight: 10,
                                                            }}
                                                        >
                                                            <CloseIcon />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </span>
                            ) : (
                                <div
                                    className={styles.emptyProductBox}
                                    style={{ marginBottom: 10 }}
                                    onClick={() => handleProductSearch()}
                                >
                                    <Button variant={"secondary"}>+ Add Products</Button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </FormLayout>
        </>
    );
};

export default InclusionExclusionProducts;
